import { useEffect, useMemo, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import api from "../api";
import { useAuth } from "../contexts/AuthContext";
import "./TakofyMobileShell.css";

const navItems = [
  ["/", "Maçlar", "⚽"],
  ["/tahmin-manager", "Tahmin", "🎯"],
  ["/fantezi", "Fantezi", "♟"],
  ["/ligler", "Ligler", "▦"],
  ["/siralamalar", "UEFA", "🏆"],
  ["/oyuncu-liderleri", "Oyuncular", "★"],
  ["/profil", "Profil", "●"],
];

function routeActive(pathname, target) {
  if (target === "/") return pathname === "/" || pathname.startsWith("/maclar/") || pathname.startsWith("/vs/");
  if (target === "/oyuncu-liderleri") return pathname === target || pathname === "/oyuncu-karsilastirma" || pathname === "/power-99-degisim" || pathname.startsWith("/oyuncular/");
  if (target === "/tahmin-manager") return pathname.startsWith('/tahmin-manager');
  if (target === "/fantezi") return pathname.startsWith('/fantezi');
  return pathname === target || pathname.startsWith(`${target}/`);
}

export default function TakofyMobileShell({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logoutLocal } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const [installEvent, setInstallEvent] = useState(null);
  const [unreadCount, setUnreadCount] = useState(0);
  const [installHidden, setInstallHidden] = useState(() => sessionStorage.getItem("takofy_install_hidden") === "1");
  const standalone = useMemo(() => window.matchMedia?.("(display-mode: standalone)")?.matches || window.navigator.standalone === true, []);
  const mobileViewport = useMemo(() => window.matchMedia?.("(max-width: 720px)")?.matches === true, []);

  useEffect(() => setMenuOpen(false), [location.pathname]);

  useEffect(() => {
    if (!user) { setUnreadCount(0); return undefined; }
    let active = true;
    const refresh = () => api.get("/football/me/notifications?limit=1").then(({ data }) => active && setUnreadCount(Number(data?.unreadCount || 0))).catch(() => {});
    refresh();
    const timer = window.setInterval(refresh, 60000);
    return () => { active = false; window.clearInterval(timer); };
  }, [user, location.pathname]);

  useEffect(() => {
    const captureInstall = (event) => {
      event.preventDefault();
      setInstallEvent(event);
    };
    window.addEventListener("beforeinstallprompt", captureInstall);
    return () => window.removeEventListener("beforeinstallprompt", captureInstall);
  }, []);

  const install = async () => {
    if (!installEvent) return;
    await installEvent.prompt();
    await installEvent.userChoice;
    setInstallEvent(null);
    setInstallHidden(true);
    sessionStorage.setItem("takofy_install_hidden", "1");
  };

  const dismissInstall = () => {
    setInstallHidden(true);
    sessionStorage.setItem("takofy_install_hidden", "1");
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } finally {
      logoutLocal();
      if ("caches" in window) {
        const keys = await window.caches.keys();
        await Promise.all(keys.filter((key) => key.startsWith("takofy-")).map((key) => window.caches.delete(key)));
      }
      navigate("/login", { replace: true, state: { signedOut: true } });
    }
  };

  return <div className="takofy-app-shell">
    <header className="takofy-mobile-header">
      <Link className="takofy-mobile-header__brand" to="/" aria-label="Takofy Maç Merkezi">
        <img src="/brand/takofy-192.png" alt=""/><span><strong>TAKOFY <b>LİG</b></strong><small>(v18)</small></span>
      </Link>
      <button type="button" className={`takofy-mobile-header__toggle${menuOpen ? " is-open" : ""}`} aria-label={menuOpen ? "Menüyü kapat" : "Menüyü aç"} aria-expanded={menuOpen} onClick={() => setMenuOpen((value) => !value)}><i/><i/><i/></button>
      <nav className={menuOpen ? "is-open" : ""} aria-label="Takofy ana menü">
        {navItems.slice(0, 5).map(([to, label]) => <Link key={to} to={to}>{label}</Link>)}
        {user ? <><Link to="/profil">{user.username || "Profil"}</Link>{String(user.role).toLowerCase() === "admin" ? <Link to="/futbol-admin">Admin</Link> : null}<button type="button" onClick={logout}>Çıkış</button></> : <Link to="/login" state={{ from: `${location.pathname}${location.search}` }}>Giriş yap</Link>}
      </nav>
    </header>

    {children}

    {mobileViewport && !standalone && installEvent && !installHidden ? <aside className="takofy-install" role="status"><span><b>Takofy'yi telefona kur</b><small>Daha hızlı, tam ekran erişim.</small></span><button type="button" onClick={install}>Kur</button><button type="button" className="takofy-install__close" onClick={dismissInstall} aria-label="Kurulum önerisini kapat">×</button></aside> : null}

    <nav className="takofy-bottom-nav" aria-label="Mobil ana navigasyon">
      {navItems.map(([to, label, icon]) => <Link key={to} to={to} className={routeActive(location.pathname, to) ? "is-active" : ""} aria-current={routeActive(location.pathname, to) ? "page" : undefined}><i aria-hidden="true">{icon}</i><span>{label}</span>{to==="/profil"&&unreadCount?<b className="takofy-bottom-nav__badge" aria-label={`${unreadCount} okunmamış bildirim`}>{unreadCount>99?"99+":unreadCount}</b>:null}</Link>)}
    </nav>
  </div>;
}
